import React from "react";
import "./style.css";

import { CourseTeacherBio } from "../../components/CourseTeacherBio";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Pagination, Navigation } from 'swiper/modules';


export const CourseLandingTeachers = ({ teachers }) => {

  if (document.body.clientWidth <= 576)
    return (
      <Swiper
        centeredSlides={true}
        slidesPerView={1.25}
        observer={false}
        observeParents={false}
        spaceBetween={'10'}
        rewind={false}
        navigation={false}
        pagination={{
          enabled: true,
          clickable: true
        }}
        modules={[Pagination, Navigation]}
        className="course_landing_image_gallery_mobile"
      >
        {
          teachers.map((teacher) => {

            return (
              <SwiperSlide key={teacher.name}>
                <CourseTeacherBio
                  key={teacher.name}
                  name={teacher.name}
                  subtitle={teacher.undertitle}
                  description={teacher.bio}
                  image={teacher.image}
                />
              </SwiperSlide>
            );

          })
        }
      </Swiper>
    );


  return (

    teachers.map((teacher) => {

      return (
        <CourseTeacherBio
          key={teacher.name}
          name={teacher.name}
          subtitle={teacher.undertitle}
          description={teacher.bio}
          image={teacher.image}
        />
      );

    })
  );

};
